import styled from "styled-components";
import img1 from "../../../../../assets/img/contactless.jpg";
import img2 from "../../../../../assets/img/contactless1.jpg";
import img3 from "../../../../../assets/img/image3.jpg";
import { blueColor, goldColor } from "../../../../styled/Theme";
import {
  ArrowRightOutlined,
  ClockCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";

const categories = [
  "All",
  "Fintech",
  "Government",
  "SACCOs",
  "Payments",
  "Inclusion",
];

const featuredPost = {
  category: "Fintech",
  categoryColor: blueColor,
  title: "Digital Payments & Financial Inclusion in Uganda",
  excerpt:
    "How digital platforms like OnePayX are transforming access to financial services and expanding inclusion across communities — from urban centres to rural areas.",
  author: "OnePayX Editorial",
  date: "Mar 8, 2026",
  readTime: "6 min read",
  image: img1,
  href: "#",
};

const posts = [
  {
    category: "Government",
    categoryColor: "#0ea5e9",
    title: "Public-Sector Digitisation & Smart Cities",
    excerpt:
      "Modernising municipal revenue collection through secure digital platforms and real-time enforcement tools.",
    author: "Policy Desk",
    date: "Mar 5, 2026",
    readTime: "4 min read",
    image: img2,
    href: "#",
    size: "large",
  },
  {
    category: "SACCOs",
    categoryColor: goldColor,
    title: "SACCO Digitisation & Community Finance",
    excerpt:
      "Empowering SACCOs with transparent, real-time digital payments and member management.",
    author: "Finance Team",
    date: "Feb 28, 2026",
    readTime: "5 min read",
    image: img3,
    href: "#",
    size: "large",
  },
  {
    category: "Payments",
    categoryColor: "#22c55e",
    title: "The Rise of Cashless Parking in East Africa",
    excerpt:
      "How municipalities are replacing cash with QR-based digital payments to cut disputes and increase revenue.",
    author: "Tech Desk",
    date: "Feb 20, 2026",
    readTime: "3 min read",
    image: img1,
    href: "#",
    size: "small",
  },
  {
    category: "Inclusion",
    categoryColor: "#a855f7",
    title: "USSD Banking: Bridging the Gap for the Unbanked",
    excerpt:
      "Why feature-phone access remains critical for financial inclusion in sub-Saharan Africa.",
    author: "Research Team",
    date: "Feb 14, 2026",
    readTime: "7 min read",
    image: img2,
    href: "#",
    size: "small",
  },
  {
    category: "Fintech",
    categoryColor: blueColor,
    title: "API-First Infrastructure for African Governments",
    excerpt:
      "Building interoperable payment rails that connect citizens, businesses, and institutions seamlessly.",
    author: "Engineering",
    date: "Feb 10, 2026",
    readTime: "5 min read",
    image: img3,
    href: "#",
    size: "small",
  },
];

export default function BlogsInsights() {
  return (
    <Wrapper>
      <Inner className="container">
        {/* ── Header ── */}
        <Header>
          <HeaderLeft
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-delay="80"
          >
            <Eyebrow>
              <EyebrowDot />
              Blogs &amp; Insights
            </Eyebrow>
            <PageTitle>
              Ideas shaping
              <br />
              <GoldWord>digital Africa.</GoldWord>
            </PageTitle>
          </HeaderLeft>
          <HeaderRight
            data-aos="fade-left"
            data-aos-duration="700"
            data-aos-delay="160"
          >
            <HeaderSubline>
              Insights on digital payments, public-sector innovation, and
              financial inclusion across Uganda and Africa.
            </HeaderSubline>
          </HeaderRight>
        </Header>

        {/* ── Category filter ── */}
        <FilterRow
          data-aos="fade-up"
          data-aos-duration="550"
          data-aos-delay="220"
        >
          {categories.map((c, i) => (
            <FilterChip key={i} $active={i === 0}>
              {c}
            </FilterChip>
          ))}
        </FilterRow>

        {/* ── Featured post ── */}
        <FeaturedCard
          href={featuredPost.href}
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="300"
        >
          <FeaturedImageWrap>
            <FeaturedImage src={featuredPost.image} alt={featuredPost.title} />
            <FeaturedImageGrad />
            <FeaturedBadge $color={featuredPost.categoryColor}>
              ★ Featured
            </FeaturedBadge>
          </FeaturedImageWrap>

          <FeaturedContent>
            <FeaturedCat $color={featuredPost.categoryColor}>
              {featuredPost.category}
            </FeaturedCat>
            <FeaturedTitle>{featuredPost.title}</FeaturedTitle>
            <FeaturedExcerpt>{featuredPost.excerpt}</FeaturedExcerpt>
            <FeaturedMeta>
              <MetaItem>
                <UserOutlined /> {featuredPost.author}
              </MetaItem>
              <MetaDot />
              <MetaItem>
                <ClockCircleOutlined /> {featuredPost.readTime}
              </MetaItem>
              <MetaDot />
              <MetaItem>{featuredPost.date}</MetaItem>
            </FeaturedMeta>
            <FeaturedCta>
              Read Article <ArrowRightOutlined />
            </FeaturedCta>
          </FeaturedContent>
        </FeaturedCard>

        {/* ── Post grid ── */}
        <PostGrid>
          {/* Large cards (first 2) */}
          {posts
            .filter((p) => p.size === "large")
            .map((p, i) => (
              <LargeCard
                key={i}
                href={p.href}
                data-aos="fade-up"
                data-aos-delay={380 + i * 100}
                data-aos-duration="700"
              >
                <LargeCardImageWrap>
                  <LargeCardImage src={p.image} alt={p.title} />
                  <LargeCardGrad $color={p.categoryColor} />
                </LargeCardImageWrap>
                <LargeCardBody>
                  <PostCat $color={p.categoryColor}>{p.category}</PostCat>
                  <LargeCardTitle>{p.title}</LargeCardTitle>
                  <LargeCardExcerpt>{p.excerpt}</LargeCardExcerpt>
                  <PostMeta>
                    <MetaItem>
                      <ClockCircleOutlined /> {p.readTime}
                    </MetaItem>
                    <MetaDot />
                    <MetaItem>{p.date}</MetaItem>
                  </PostMeta>
                </LargeCardBody>
                <LargeCardCta $color={p.categoryColor}>
                  Read more <ArrowRightOutlined />
                </LargeCardCta>
              </LargeCard>
            ))}

          {/* Small cards column */}
          <SmallCardsCol>
            <SmallColLabel>More Articles</SmallColLabel>
            {posts
              .filter((p) => p.size === "small")
              .map((p, i) => (
                <SmallCard
                  key={i}
                  href={p.href}
                  data-aos="fade-left"
                  data-aos-delay={460 + i * 80}
                  data-aos-duration="600"
                >
                  <SmallCardImage src={p.image} alt={p.title} />
                  <SmallCardContent>
                    <PostCat $color={p.categoryColor}>{p.category}</PostCat>
                    <SmallCardTitle>{p.title}</SmallCardTitle>
                    <PostMeta>
                      <MetaItem>
                        <ClockCircleOutlined /> {p.readTime}
                      </MetaItem>
                      <MetaDot />
                      <MetaItem>{p.date}</MetaItem>
                    </PostMeta>
                  </SmallCardContent>
                  <SmallCardArrow $color={p.categoryColor}>
                    <ArrowRightOutlined />
                  </SmallCardArrow>
                </SmallCard>
              ))}
          </SmallCardsCol>
        </PostGrid>

        {/* ── Load more ── */}
        <LoadMoreRow
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="200"
        >
          <LoadMoreBtn>
            Load More Articles <ArrowRightOutlined />
          </LoadMoreBtn>
        </LoadMoreRow>
      </Inner>
    </Wrapper>
  );
}

/* ── Animations ── */
// const shimmer = keyframes`
//   0%   { background-position: -200% center; }
//   100% { background-position:  200% center; }
// `;

/* ── Styles ── */

const Wrapper = styled.section`
  background: #f8fafc;
  padding: 72px 0 88px;
`;

const Inner = styled.div`
  padding: 0 20px;
`;

/* Header */
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: flex-end;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const HeaderLeft = styled.div``;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: ${blueColor};
  background: ${blueColor}0f;
  border: 1px solid ${blueColor}28;
  border-radius: 20px;
  padding: 4px 14px;
  margin-bottom: 16px;
`;

const EyebrowDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${goldColor};
`;

const PageTitle = styled.h1`
  font-size: 42px;
  font-weight: 900;
  color: #0a1628;
  letter-spacing: -1.6px;
  line-height: 1.08;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

const GoldWord = styled.span`
  color: ${goldColor};
`;

const HeaderRight = styled.div`
  padding-bottom: 6px;
`;

const HeaderSubline = styled.p`
  font-size: 15px;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
  max-width: 480px;
`;

/* Filter */
const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 36px;
`;

const FilterChip = styled.button<{ $active?: boolean }>`
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 20px;
  padding: 6px 16px;
  border: 1px solid ${(p) => (p.$active ? blueColor : "#e2e8f0")};
  background: ${(p) => (p.$active ? blueColor : "#ffffff")};
  color: ${(p) => (p.$active ? "#fff" : "#475569")};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${blueColor};
    color: ${blueColor};
    background: ${blueColor}08;
  }
`;

/* ── Featured Card ── */
const FeaturedCard = styled.a`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #ffffff;
  border: 1px solid #e8f0f8;
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 24px;
  text-decoration: none;
  transition: all 0.28s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 20px 56px rgba(26, 111, 181, 0.13);
    transform: translateY(-4px);
    border-color: ${blueColor}30;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const FeaturedImageWrap = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 320px;
`;

const FeaturedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.7s ease;

  ${FeaturedCard}:hover & {
    transform: scale(1.05);
  }
`;

const FeaturedImageGrad = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    rgba(7, 20, 55, 0.45) 0%,
    transparent 60%
  );
`;

const FeaturedBadge = styled.div<{ $color: string }>`
  position: absolute;
  top: 18px;
  left: 18px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.7px;
  color: #fff;
  background: ${(p) => p.$color};
  border-radius: 6px;
  padding: 4px 10px;
`;

const FeaturedContent = styled.div`
  padding: 36px 36px 28px;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    padding: 24px 20px;
  }
`;

const FeaturedCat = styled.div<{ $color: string }>`
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: ${(p) => p.$color};
  margin-bottom: 12px;
`;

const FeaturedTitle = styled.h2`
  font-size: 24px;
  font-weight: 900;
  color: #0a1628;
  letter-spacing: -0.7px;
  line-height: 1.25;
  margin: 0 0 14px;
`;

const FeaturedExcerpt = styled.p`
  font-size: 14.5px;
  color: #64748b;
  line-height: 1.7;
  margin: 0 0 20px;
  flex: 1;
`;

const FeaturedMeta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 20px;
`;

const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
`;

const MetaDot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd5e1;
`;

const FeaturedCta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13.5px;
  font-weight: 700;
  color: ${blueColor};
  transition: gap 0.2s;

  ${FeaturedCard}:hover & {
    gap: 11px;
  }
`;

/* ── Post Grid ── */
const PostGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 360px;
  gap: 20px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

/* Large cards */
const LargeCard = styled.a`
  background: #ffffff;
  border: 1px solid #e8f0f8;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  transition: all 0.26s ease;

  &:hover {
    box-shadow: 0 14px 40px rgba(26, 111, 181, 0.12);
    transform: translateY(-4px);
    border-color: ${blueColor}30;
  }
`;

const LargeCardImageWrap = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;
`;

const LargeCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;

  ${LargeCard}:hover & {
    transform: scale(1.06);
  }
`;

const LargeCardGrad = styled.div<{ $color: string }>`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    transparent 40%,
    ${(p) => p.$color}22 100%
  );
`;

const LargeCardBody = styled.div`
  padding: 20px 22px 14px;
  flex: 1;
`;

const PostCat = styled.div<{ $color: string }>`
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${(p) => p.$color};
  margin-bottom: 8px;
`;

const LargeCardTitle = styled.h3`
  font-size: 17px;
  font-weight: 800;
  color: #0a1628;
  letter-spacing: -0.4px;
  line-height: 1.3;
  margin: 0 0 9px;
`;

const LargeCardExcerpt = styled.p`
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 14px;
`;

const PostMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

const LargeCardCta = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  color: ${(p) => p.$color};
  padding: 13px 22px;
  border-top: 1px solid #f1f5f9;
  transition:
    gap 0.2s,
    background 0.2s;

  ${LargeCard}:hover & {
    gap: 10px;
    background: ${(p) => p.$color}06;
  }
`;

/* Small cards column */
const SmallCardsCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 1100px) {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
  }

  @media (max-width: 700px) {
    grid-column: 1;
    grid-template-columns: 1fr;
  }
`;

const SmallColLabel = styled.div`
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #94a3b8;
  padding-bottom: 4px;
  border-bottom: 1px solid #e8f0f8;

  @media (max-width: 1100px) {
    grid-column: 1 / -1;
  }
`;

const SmallCard = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border: 1px solid #e8f0f8;
  border-radius: 14px;
  padding: 14px;
  text-decoration: none;
  transition: all 0.22s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 8px 24px rgba(26, 111, 181, 0.1);
    transform: translateX(4px);
    border-color: ${blueColor}30;
  }
`;

const SmallCardImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
`;

const SmallCardContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const SmallCardTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SmallCardArrow = styled.div<{ $color: string }>`
  color: ${(p) => p.$color};
  font-size: 13px;
  flex-shrink: 0;
  opacity: 0;
  transition:
    opacity 0.2s,
    transform 0.2s;
  transform: translateX(-4px);

  ${SmallCard}:hover & {
    opacity: 1;
    transform: translateX(0);
  }
`;

/* Load more */
const LoadMoreRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 48px;
`;

const LoadMoreBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: ${blueColor};
  background: #ffffff;
  border: 1.5px solid ${blueColor}40;
  border-radius: 12px;
  padding: 13px 28px;
  cursor: pointer;
  transition: all 0.22s;

  &:hover {
    background: ${blueColor};
    color: #fff;
    border-color: ${blueColor};
    gap: 12px;
  }
`;
